import Vue from "vue";
const io = require("socket.io-client");
const that = Vue.prototype;
import state from "../lib/state";

that.state = state;

//config socket
export default that.$socket = async function () {
  const socket = await io("https://sockete.tiirex.website/socket", {
    path: "/vtp",
    transports: ["websocket"],
    upgrade: false,
    connected: true,
    reconnection: true,
    rejectUnauthorized: false,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0.5,
    timeout: 20000,
    auth: {
      token: state.token,
    },
  });

  socket.on("connect", () => {
    this.state.loading = false;
    // console.log("connected");
  });

  socket.on("USD", (data) => {
    let parsedDate = JSON.parse(data);
    this.$store.commit("setUsd", parsedDate);
    // console.log("usd", this.$store.state.usd);
  });

  socket.on("USDT", (data) => {
    let parsedDate = JSON.parse(data);
    this.$store.commit("setUsdt", parsedDate);
    // console.log("usdt", this.$store.state.usdt);
  });

  socket.on("TOMAN_MARKET_INFO", (data) => {
    let parsedDate = JSON.parse(data);
    // console.log(parsedDate)
    this.$store.commit("setTomanMarketInfo", parsedDate.content);
    // console.log("market", this.$store.state.market);
  });

  socket.on("TETHER_MARKET_INFO", (data) => {
    let parsedDate = JSON.parse(data);
    this.$store.commit("setTetherMarketInfo", parsedDate.content);
    // console.log("marketUSDT", this.$store.state.marketUSDT);
  });

  socket.on("disconnect", () => {
    this.state.loading = true;
    // console.log("disconnected");
  });

  return socket;
};
